import useSWR from 'swr'
import { API_URL } from '@/utils/constants'

// The ownership endpoint's escrow field is not the active order book. In
// particular, protected listings may be absent there. Use the public listing
// endpoint also used by the transaction builder; it includes protection markers.
export async function fetchInscriptionListing(id: string, fresh = false) {
	const url = `${API_URL}/market/escrow/${encodeURIComponent(id)}${
		fresh ? `?refresh=${Date.now()}` : ''
	}`
	const response = await fetch(url, { cache: 'no-store', signal: AbortSignal.timeout(8000) })
	if (response.status === 404) return null
	if (!response.ok) {
		// A 5xx is the API restarting or overloaded, not a fact about the
		// listing; say so, so the retry copy can promise recovery.
		throw new Error(
			response.status >= 500
				? 'Ordinals Wallet is briefly unavailable. Retry in a few seconds.'
				: 'Could not check this listing. Please try again.'
		)
	}
	const listing = await response.json()
	if (
		!listing ||
		listing.error ||
		!(Number(listing.satoshi_price) > 0) ||
		!listing.seller_address ||
		!listing.outpoint
	) {
		throw new Error('Could not check this listing. Please try again.')
	}
	return listing
}

export default function useInscriptionListing(id: string) {
	return useSWR(
		id ? ['inscription-listing', id] : null,
		([, inscriptionId]) => fetchInscriptionListing(inscriptionId),
		{
			revalidateOnFocus: true,
			refreshInterval: 15000,
			// A deploy blip or timeout must not leave the modal stuck on
			// "unavailable": retry a few times on its own, then rely on the
			// 15s refresh and the Retry button.
			shouldRetryOnError: true,
			errorRetryCount: 3,
			errorRetryInterval: 4000
		}
	)
}
